import React from 'react';
import { RichText } from './RichText';
import { NarrativeLens, SummaryLensId } from './types';
interface SummaryTabProps {
  narrative: NarrativeLens;
  summaryLens: SummaryLensId;
  onLensChange: (lens: SummaryLensId) => void;
  hasBlockers: boolean;
  isReviewer: boolean;
  onGoToFindings: () => void;
}
export function SummaryTab({
  narrative,
  summaryLens,
  onLensChange,
  hasBlockers,
  isReviewer,
  onGoToFindings
}: SummaryTabProps) {
  const lenses: [SummaryLensId, string][] = [['marketing', '📣 Marketing'], ['compliance', '⚖️ Compliance']];
  return <div style={{
    padding: '16px 20px'
  }} data-id="element-220">
      {/* Lens Switcher */}
      <div style={{
      display: 'flex',
      gap: 5,
      marginBottom: 16
    }} data-id="element-221">
        {lenses.map(([id, label]) => <button key={id} onClick={() => onLensChange(id)} style={{
        padding: '4px 10px',
        borderRadius: 16,
        border: summaryLens === id ? '1.5px solid #1C2530' : '1px solid #E6E4DF',
        background: summaryLens === id ? '#1C2530' : 'white',
        color: summaryLens === id ? 'white' : '#5A6B7C',
        fontSize: 10.5,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'inherit'
      }} data-id="element-222">
            {label}
          </button>)}
      </div>

      {/* Greeting */}
      <div style={{
      fontFamily: "'Lora', Georgia, serif",
      fontSize: 18,
      color: '#1C2530',
      marginBottom: 14,
      lineHeight: 1.4,
      animation: 'fadeUp 0.3s ease both'
    }} data-id="element-223">
        {narrative.greeting}
      </div>

      {/* Sections */}
      {narrative.sections.map((sec, i) => <div key={i} style={{
      marginBottom: 18,
      animation: `fadeUp 0.3s ease ${0.05 + i * 0.04}s both`
    }} data-id="element-224">
          <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        marginBottom: 6
      }} data-id="element-225">
            {sec.type === 'blockers' && <span style={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          background: '#B44D4D'
        }} data-id="element-226" />}
            <h3 style={{
          fontSize: 11,
          fontWeight: 700,
          color: sec.type === 'blockers' ? '#B44D4D' : '#5A6B7C',
          textTransform: 'uppercase',
          letterSpacing: '0.06em'
        }} data-id="element-227">
              {sec.heading}
            </h3>
          </div>
          <div style={{
        fontSize: 13,
        color: '#4A5B6C',
        lineHeight: 1.6
      }} data-id="element-228">
            <RichText text={sec.content} data-id="element-229" />
          </div>
        </div>)}

      {/* Closing */}
      {narrative.closing && <div style={{
      padding: '10px 14px',
      background: hasBlockers ? '#FFFBEB' : '#F7FDF9',
      border: `1px solid ${hasBlockers ? '#FDE68A' : '#D1FAE5'}`,
      borderRadius: 7,
      fontSize: 13,
      color: hasBlockers ? '#92400E' : '#065F46',
      lineHeight: 1.6
    }} data-id="element-230">
          {narrative.closing}
        </div>}

      {/* Actions */}
      <div style={{
      display: 'flex',
      gap: 6,
      marginTop: 14
    }} data-id="element-231">
        <button style={{
        padding: '7px 14px',
        borderRadius: 6,
        border: '1.5px solid #E6E4DF',
        background: 'white',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 11.5,
        fontWeight: 600,
        color: '#5A6B7C'
      }} data-id="element-232">
          📋 Copy
        </button>
        {isReviewer && <button style={{
        padding: '7px 14px',
        borderRadius: 6,
        border: '1.5px solid #E6E4DF',
        background: 'white',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 11.5,
        fontWeight: 600,
        color: '#5A6B7C'
      }} data-id="element-233">
            ✉ Send to Allison
          </button>}
        <button onClick={onGoToFindings} style={{
        padding: '7px 14px',
        borderRadius: 6,
        border: '1.5px solid #E6E4DF',
        background: 'white',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 11.5,
        fontWeight: 600,
        color: '#1C2530'
      }} data-id="element-234">
          Findings →
        </button>
      </div>
    </div>;
}